import {
  PostProcessors,
  ReportTypes,
} from '@showbie-socrative/socrative-utils';

import { ReportDeliveryType } from '../../../teacher/enums';
import { ActivityReportRequestParams } from '../../../teacher/models/reports';
import { BaseUrls } from '../BaseUrlBuilder';

export class ReportUrls extends BaseUrls {
  constructor() {
    super();
  }

  reportDeliveryUrl(reportParams: ActivityReportRequestParams) {
    const queryParams = this.buildQueryParam(reportParams);
    return `${this.baseUrl}/reports/job/user${queryParams}`;
  }

  fetchStudentRosterUrl(activityInstanceId: number) {
    return `${this.baseUrl}/activity/${activityInstanceId}/students`;
  }

  emailStudentsUrl() {
    return `${this.baseUrl}/reports/job/user?types=${ReportTypes.IndividualRosterStudentPDF}&processors=${PostProcessors.EmailStudents}`;
  }

  downloadEmptyQuizUrl() {
    return `${this.baseUrl}/reports/job/user?types=${ReportTypes.EmptyQuiz}`;
  }

  private buildQueryParam(reportParams: ActivityReportRequestParams): string {
    const paramTypes = reportParams.reportTypes;
    let fullQuery = '';

    const value = paramTypes.join(',');
    if (value) {
      fullQuery = `?types=${value}`;
    }

    let deliveryTypeParam = null;
    switch (reportParams.deliveryType) {
      case ReportDeliveryType.EMAIL_REPORT:
        deliveryTypeParam = PostProcessors.EmailTeacher;
        break;
      case ReportDeliveryType.GOOGLE_DRIVE:
        deliveryTypeParam = PostProcessors.UploadGoogle;
        break;
      default:
        deliveryTypeParam = null;
    }

    if (deliveryTypeParam) {
      if (fullQuery) {
        fullQuery += '&';
      } else {
        fullQuery = '?';
      }

      fullQuery += `processors=${deliveryTypeParam}`;
      return fullQuery;
    }

    return fullQuery;
  }
}
